import { render } from "./FileMenu.vue?vue&type=template&id=00753834"
import script from "./FileMenu.vue?vue&type=script&lang=js"
export * from "./FileMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__